import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
const isIE = /*@cc_on!@*/ false || !!document.documentMode;
if (isIE) {
  window.open("microsoft-edge:http://update.odis.co.kr/maintenance");
}

ReactDOM.render(
  <React.StrictMode>
    {isIE ? (
      <div>
        <h2>ie는 지원되지않습니다. 최신 브라우저로 접속해주세요.</h2>
      </div>
    ) : (
      <App />
    )}
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
